__turbopack_context__.v({
  "header": "ArticlesHighlightsSlider-module-scss-module__BZw_9q__header",
  "headerTitle": "ArticlesHighlightsSlider-module-scss-module__BZw_9q__headerTitle",
  "scrollbar": "ArticlesHighlightsSlider-module-scss-module__BZw_9q__scrollbar",
  "scrollbarPlaceholder": "ArticlesHighlightsSlider-module-scss-module__BZw_9q__scrollbarPlaceholder",
  "scrollbarWrapper": "ArticlesHighlightsSlider-module-scss-module__BZw_9q__scrollbarWrapper",
  "skeletonCard": "ArticlesHighlightsSlider-module-scss-module__BZw_9q__skeletonCard",
  "skeletonWrapper": "ArticlesHighlightsSlider-module-scss-module__BZw_9q__skeletonWrapper",
  "slide": "ArticlesHighlightsSlider-module-scss-module__BZw_9q__slide",
});
